import { FC, PropsWithChildren, Suspense, memo } from 'react';

import { Navigate, useLocation } from 'react-router-dom';

import { PageLoader } from '@elements';
import { useAccount } from '@store/account';

export const LazyAccessControl: FC<PropsWithChildren> = memo(({ children }) => {
  const location = useLocation();

  const { loggedIn } = useAccount();

  // Verify authenticated or not
  if (!loggedIn) {
    return <Navigate to="/login" state={{ from: location.pathname }} />;
  }

  return <Suspense fallback={<PageLoader />}>{children}</Suspense>;
});
